import { createGlobalStyle } from 'styled-components'

import { color } from 'styles/colors'
import { reset } from 'styles/reset'
import { icons } from 'styles/icons'
import { swiper } from 'styles/swiper'
import { focusOutline } from 'styles/shared'

const headerStyle = `
  color: ${color('headerText')};
  font-weight: 700;
  line-height: 1;
`
// WIP: go through button and input styles to make sure what's there is needed
const GlobalStyle = createGlobalStyle`
  ${reset}

  *, *::before, *::after {
    -webkit-box-sizing: inherit;
    box-sizing: inherit;
  }

  html {
    scroll-behavior: smooth;
    box-sizing: border-box;
    font-size: 14px;
    -webkit-text-size-adjust: 100%;
  }

  body {
    font-weight: 400;
    color: ${color('primaryText')};
    height: 100vh;
    display: flex;
    flex-direction: column;

    margin: 0;
    padding: 0;
    font-family: "Inter", sans-serif;
    font-weight: normal;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }

  button {
    -webkit-appearance: button;
    cursor: pointer;
  }
  button, select {
    text-transform: none;
  }
  button, input {
    line-height: normal;
  }
  button, input, select, textarea {
    font-family: inherit;
    font-size: 100%;
    margin: 0;
  }
  button, input, optgroup, select, textarea {
    font-family: inherit;
  }
  button {
    padding: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0;
    background: transparent;
    line-height: 1;
    cursor: auto;
  }
  button, select {
    text-transform: none;
  }
  button, input {
    overflow: visible;
  }
  button, input, optgroup, select, textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }

  input, textarea {
    writing-mode: horizontal-tb !important;
    border: 1px solid ${color('border')};
    box-shadow: ${color('shadowSubtle')} 0px 1px 2px 0px inset;
    padding-left: 8px;
  }

  [type='text']:focus, [type='password']:focus, [type='date']:focus, [type='datetime']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='week']:focus, [type='email']:focus, [type='number']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='url']:focus, [type='color']:focus, textarea:focus, select:focus {
    outline: none;
    border: 1px solid ${color('inputBorder')};
    background-color: ${color('paneBackground')};
    -webkit-box-shadow: 0 0 5px ${color('baseBorder')};
    box-shadow: 0 0 5px ${color('baseBorder')};
    -webkit-transition: border-color 0.25s ease-in-out, -webkit-box-shadow 0.5s;
    transition: border-color 0.25s ease-in-out, -webkit-box-shadow 0.5s;
    transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
    transition: box-shadow 0.5s, border-color 0.25s ease-in-out, -webkit-box-shadow 0.5s;
  }

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid ${color('baseBorder')};
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>");
    background-origin: content-box;
    background-position: right -1.14286rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    outline: none;
    background-color: ${color('selectButton')};
    cursor: pointer;
    box-sizing: border-box;
    width: 100%;

    :hover {
      background-color: ${color('selectButtonHover')};
    }
  }

  .root {
    flex-grow: 1;
  }

  @font-face {
    font-family: 'inter.regular';
    src: url('/fonts/inter-regular.ttf');
  }

  @font-face {
    font-family: 'inter.bold';
    src: url('src/fonts/inter-bold.ttf');
  }

  h1 {
    font-size: 28px;
    ${headerStyle}
  }

  h2 {
    font-size: 18px;
    ${headerStyle}
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-size: 16px;
    ${headerStyle}
    margin-top: 0;
  }

  h4, h5, h6 {
    font-size: 14px;
    ${headerStyle}
  }

  p {
    line-height: 1.1;
  }

  a {
    color: ${color('anchor')};
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;

    &:hover, &:focus {
      color: ${color('anchorHover')};
    }

    ${focusOutline()}
  }

  ${swiper}
  ${icons}
`
export default GlobalStyle
